import get from 'transmute/get';
export const getDeliveryIdentifierValue = get('value');
export const getDeliveryIdentifierType = get('type');